import React from "react";

import { CloseX as CloseIcon } from "@hl/base-components/lib/assets/icons.generated";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import {
  Box,
  createStyles,
  Divider,
  Flex,
  UnstyledButton,
  Text,
} from "@mantine/core";

const useStyles = createStyles((theme) => ({
  details: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  detailsMain: {
    height: "100%",
    backgroundColor: theme.colors.baseBackground[0],
    borderRadius: theme.radius.md,
  },
  detailsHeader: {
    height: 56,
    alignItems: "center",
    paddingLeft: 16,
    paddingRight: 16,
  },
  scrollable: {
    overflowY: "auto",
    overflowX: "hidden",
    height: "calc(100% - 86px)",
    paddingLeft: 16,
    paddingRight: 16,
  },
}));

type InnerCardProps = {
  onClose: () => void;
  title: React.ReactNode;
  bottomArea?: React.ReactNode;
};
const InnerCard: React.FC<React.PropsWithChildren<InnerCardProps>> = ({
  onClose,
  title,
  children,
  bottomArea,
}) => {
  const { classes, theme } = useStyles();
  return (
    <div className={classes.details}>
      <div className={classes.detailsMain}>
        <Flex justify="space-between" className={classes.detailsHeader}>
          <Text>{title}</Text>
          <UnstyledButton
            onClick={onClose}
            aria-label="close details"
            p={5}
            pt={10}
          >
            <CloseIcon
              width={8}
              fill={theme.fn.themeColor(TEXT_COLOR.PRIMARY)}
            />
          </UnstyledButton>
        </Flex>
        <Divider />
        <Box pt="md" className={classes.scrollable}>
          {children}
        </Box>
      </div>
      {bottomArea && (
        <div>
          <Divider />
          <Box m={16}>{bottomArea}</Box>
        </div>
      )}
    </div>
  );
};

export default InnerCard;
